import { type ComponentProps, type FromSanityGraphQL } from "@ts/components";
import { type SectionVideo } from "@ts/sanity";
import React, { type FC } from "react";

type VideoInputProps = ComponentProps & FromSanityGraphQL<SectionVideo>;

export type VideoOutputProps = VideoInputProps & {
  handleClick: () => void;
};

export const withVideo =
  (Component: FC<VideoOutputProps>) =>
  ({ name = "Video", analytics, ...props }: VideoInputProps) => {
    Component.displayName = name;
    return <Component {...props} />;
  };
